import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_URL = "/novapine-logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-novapine-brown text-white/90">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Novapine"
                className="h-14 w-auto object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <span className="font-heading font-bold text-xl tracking-tight text-white">
                NOVAPINE
              </span>
            </div>
            <p className="font-body text-sm text-white/60 leading-relaxed max-w-xs">
              Agro-processing specialists delivering consistent, high-quality
              pineapple products since 2007.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-[0.15em] text-novapine-gold mb-6">
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                data-testid="footer-link-home"
                className="font-body text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                Home
              </Link>
              <Link
                to="/about"
                data-testid="footer-link-about"
                className="font-body text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                About
              </Link>
              <Link
                to="/products"
                data-testid="footer-link-products"
                className="font-body text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                Products
              </Link>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="font-body text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-[0.15em] text-novapine-gold mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-novapine-gold mt-0.5 shrink-0" />
                <span className="font-body text-sm text-white/70">
                  Hluhluwe, KwaZulu-Natal, South Africa
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-novapine-gold shrink-0" />
                <a href="tel:+27722528030" className="font-body text-sm text-white/70 hover:text-white transition-colors">
                  Lloyd: +27 72 252 8030
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-novapine-gold shrink-0" />
                <a href="tel:+27825598740" className="font-body text-sm text-white/70 hover:text-white transition-colors">
                  James: +27 82 559 8740
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-novapine-gold shrink-0" />
                <span className="font-body text-sm text-white/70">
                  info@novapine.co.za
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="font-body text-xs text-white/40">
            &copy; {new Date().getFullYear()} Novapine. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
